export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-line text-background-50 text-base"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">51网址导航</span>
            </div>
            <p className="text-sm leading-relaxed text-background-400 mb-4">
              51网址导航聚合网址导航123、123导航、导航123等数字标识快捷入口，
              每日追踪全网热点事件与吃瓜资讯。网址123，易记好用的上网导航平台，
              让你的每一次上网都更简单高效。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                <i className="ri-github-line text-sm"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热门专题', href: '#index' },
                { label: '精彩视频', href: '#media' },
                { label: '最新快讯', href: '#updates' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热门排行', href: '#ranking' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">服务支持</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400 cursor-pointer hover:text-background-100 transition-colors duration-200">
                站点收录申请
              </span>
              <span className="text-sm text-background-400 cursor-pointer hover:text-background-100 transition-colors duration-200">
                内容投稿指南
              </span>
              <span className="text-sm text-background-400 cursor-pointer hover:text-background-100 transition-colors duration-200">
                广告合作咨询
              </span>
              <span className="text-sm text-background-400 cursor-pointer hover:text-background-100 transition-colors duration-200">
                用户反馈通道
              </span>
              <span className="text-sm text-background-400 cursor-pointer hover:text-background-100 transition-colors duration-200">
                隐私与安全说明
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              51网址导航开放合作，欢迎各类优质网站、内容平台、工具服务加入我们的上网导航生态。
              合作伙伴区域持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51网址导航 版权所有 | 网址导航123 · 上网导航 · 在线导航
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200">用户协议</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors duration-200">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}